import { render, staticRenderFns } from "./AllHubs.vue?vue&type=template&id=e106abf4"
import script from "./AllHubs.vue?vue&type=script&lang=js"
export * from "./AllHubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports